import React from 'react';
import { Box, CircularProgress } from '@mui/material';

/** Fallback shown while a lazily loaded screen or section downloads. */
export function ScreenLoader({ fullScreen = true }) {
  return (
    <Box
      role="status"
      aria-label="Loading"
      sx={{
        height: fullScreen ? '100dvh' : 240,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        bgcolor: fullScreen ? 'var(--app-background)' : 'transparent',
      }}
    >
      <CircularProgress sx={{ color: 'var(--app-primary)' }} />
    </Box>
  );
}
